import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Select from 'react-select'
import {
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import find from 'lodash/find'
import get from 'lodash/get'
import shortid from 'shortid'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'
import TrashHover from '../../../../static/images/trash-hover.svg'
import { statusColor } from '../../helpers/color'
import { FONTS } from '../../../../constants'

const customStyles = {
  control: (base, state) => ({
    ...base,
    height: 30,
    background: !state.isDisabled ? "#FFFFFF" : '#e9ecef',
    minHeight: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    width: 15,
    padding: 0,
  }),
}

export const InfoData = (props) => {
  const { project, myProjects } = props
  const { isEdit } = props
  const { addTask, deleteProject } = props
  const projectData = timesheetHelper.findProject(project.project_id, myProjects)

  return (
    <Row>
      <CircleCol>
        <Detail>{ <Status color={ statusColor(get(project, 'status', CONSTANTS.NONSUBMIT)) } /> }</Detail>
      </CircleCol>
      <FirstCol>
        <Detail>{ projectData.project_code }: { projectData.name }</Detail>
      </FirstCol>
      <DeleteCol>
        { isEdit && <Circle onClick={ () => addTask(project.key) }>+</Circle> }
        { isEdit &&
        <Dropdown>
          <Delete tag='div'>
            ...
          </Delete>
          <DropdownMenu tag='div'>
            <DeleteItem tag='div' onClick={ () => deleteProject(project.key) }>Delete</DeleteItem>
          </DropdownMenu>
        </Dropdown>
        }
      </DeleteCol>
    </Row>
  )
}

export const TaskData = (props) => {
  const { isEdit } = props
  const { task, projectID, taskID } = props
  const { deleteTask, handleInputMyTimesheet } = props
  let location = find(props.locations, { value: task.location_id })

  if (location === undefined) {
    location = find(props.locations, { code: 'BKK' })
    if (location) handleInputMyTimesheet('location_id', location, projectID, taskID)
  }
  return (
    <Row>
      <LocationCol>
        <SelectLocation
          name='location_id'
          styles={ customStyles }
          options={ props.locations }
          isDisabled={ !isEdit }
          onChange={ (e) => handleInputMyTimesheet('location_id', e, projectID, taskID) }
          value={ location }
        />
      </LocationCol>
      <TaskCol>
        <TaskInput
          key={ shortid() }
          autoComplete='off'
          name='task_name'
          placeholder='Task...'
          disabled={ !isEdit }
          defaultValue={ task.task_name }
          onBlur={ (e) => handleInputMyTimesheet('task_name', e, projectID, taskID) }
        />
      </TaskCol>
      <AddCol>
        { isEdit && <Trash onClick={ () => deleteTask(projectID, taskID) } /> }
      </AddCol>
    </Row>
  )
}

InfoData.propTypes = {
  isEdit: PropTypes.bool,
  myProjects: PropTypes.array,
  project: PropTypes.object,
  deleteProject: PropTypes.func,
  addTask: PropTypes.func,
}
InfoData.defaultProps = {
  isEdit: false,
  data: {},
  approvers: [],
  myProjects: [],
  project: {},
  deleteProject: () => {},
  addTask: () => {},
}
TaskData.propTypes = {
  isEdit: PropTypes.bool,
  task: PropTypes.object,
  locations: PropTypes.array,
  projectID: PropTypes.string,
  taskID: PropTypes.number,
  deleteTask: PropTypes.func,
  handleInputMyTimesheet: PropTypes.func,
}
TaskData.defaultProps = {
  isEdit: false,
  locations: [],
  task: {},
  projectID: '',
  taskID: 0,
  deleteTask: () => {},
  handleInputMyTimesheet: () => {},
}

const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 15px;
  width: 15px;
  background-color: #D44B49;
  border-radius: 50%;
  margin-top: 3px;
  cursor: pointer;
`
const Status = styled(Circle)`
  background-color: ${props => props.color};
  height: 10px;
  width: 10px;
`
const Delete = styled(DropdownToggle)`
  font-size: 20px;
  text-align: center;
  height: 100%;
  color: #717171;
  margin-bottom: 0px;
`
const DeleteItem = styled(DropdownItem)`
  font-size: ${FONTS.SMALL_SIZE};
  height: 20px;
`
const TaskInput = styled(Input)`
  height: 25px;
  margin-bottom: 10px;
  font-size: ${FONTS.SMALL_SIZE};
  font-family: ${FONTS.GOTHAM} !important;
`
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 30%;
  margin-left: 1% !important;
  margin-right: 1% !important;
  @media (max-width: 575.98px) {
    width: 100%;
  }
  @media (max-width: 767.98px) {
    width: 100%;
  }
`
const FirstCol = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-top: 10px;
`
const CircleCol = styled(FirstCol)`
  width: 5%;
`
const TaskCol = styled.div`
  width: 60%;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`
const AddCol = styled(TaskCol)`
  width: 10%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 0px;
`
const DeleteCol = styled(AddCol)`
  z-index: 1;
  width: 15%;
`
const Title = styled.p`
  margin-bottom: 0px;
  font-weight: normal;
`
const Detail = styled(Title)`
  font-size: ${FONTS.SMALL_SIZE};
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  overflow: hidden;
`
const LocationCol = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  padding-right: 10px;
  margin-top: 10px;
`
const SelectLocation = styled(Select)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 100%;
  height : 100%;
  margin-bottom: 10px;
  font-size: ${FONTS.SMALL_SIZE};
`
const Trash = styled.div`
  background-image: url(${TrashHover});
  width: 15px;
  height: 15px;
  margin-top: 10px;
  cursor: pointer;
`
const Dropdown = styled(UncontrolledDropdown)`
  margin-left: 5px;
  margin-bottom: 10px;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/info-col.js